import { RouteObject } from 'react-router'
import React, { lazy } from 'react'
import ProtectRouter from '../components/protect.router'

const Institutions = lazy(() => import('../containers/institutions/institutions'))
const InstitutionsDescribe = lazy(() => import('../containers/institutions/describe/institutions.describe'))

const InstitutionsRouter: RouteObject[] = [

    {
        path: '/app/institutions',
        element: <ProtectRouter privateRouter={true} scopes={[ 'co:ra'  ]}>
            <Institutions/>
        </ProtectRouter>
    },
    {
        path: '/app/institutions/:institutionCnpj/description',
        element: <ProtectRouter privateRouter={true} scopes={[ 'co:ra' ]}>
            <InstitutionsDescribe/>
        </ProtectRouter>
    },
    {
        path: '/app/institutions/:institutionCnpj',
        element: <ProtectRouter privateRouter={true} scopes={[ 'co:ra' ]}>
            <InstitutionsDescribe/>
        </ProtectRouter>
    }
]

export default InstitutionsRouter
